/**
 * API地址配置文件
 * 吴程飞
 * 2019-03-12 08:23:03
 */
//中心重要服务
export const CenterImportant = 'http://192.168.1.200/center-important-business';
//中心一般服务
export const CenterGeneral = 'http://192.168.1.200/center-general-business';
//小程序服务
export const RunlegMiniApp = 'http://192.168.1.200/runleg-business';
//商家一般服务
export const MarketGeneral = 'http://192.168.1.200/marketnormalbusiness';
//商家重要服务
export const MarketImportant = 'http://192.168.1.200/marketimportantbusiness';
//用户重要服务
export const MemeberImportant = "http://192.168.1.200/member-important";
//用户一般服务
export const MemeberGeneral = "http://192.168.1.200/member-general";
//骑手orderhistory
export const RiderOrderhistory = "http://192.168.2.136:8764";
//骑手orderprocess
export const RiderOrderprocess = "http://192.168.1.200/orderprocessnew";

export const BackMerchantManagementImportant = "http://192.168.1.200/backstageimportant";



// WEBPACK FOOTER //
// ./src/BaseApiConfig.js